import React, { useEffect } from 'react';
import CalendarIntegrations from '../../../integrations/calendar/CalendarIntegrations';

export default function TeamLabelCalendarSyncDialog({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="cal-int-shell" role="presentation">
      <button
        type="button"
        className="cal-int-shell__backdrop"
        aria-label="Close calendar sync"
        onClick={onClose}
      />
      <div
        className="cal-int-shell__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cal-int-title"
      >
        <CalendarIntegrations onClose={onClose} />
      </div>
    </div>
  );
}
